module.exports = __webpack_public_path__ + "static/media/node-js.3dc18bc7.svg";